var map = {
	"./1.png": "0ad7",
	"./10.png": "9f5e",
	"./2.png": "9c35",
	"./3.png": "e934",
	"./4.png": "57f8",
	"./5.png": "f2b1",
	"./6.png": "4319",
	"./7.png": "8915",
	"./8.png": "baf4",
	"./9.png": "e8ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bf6";